export default __webpack_public_path__ + "static/media/Dead Sea Scrolls - All Souls Deuteronomy_02.23b80ee9.jpg";